<template>
    <div class="app">
        <AppHeader fixed>
            <SidebarToggler class="d-lg-none" display="md" mobile />
            <b-link class="navbar-brand" to="#">
                <img class="navbar-brand-full" src="img/logo.png" width="auto" height="40" alt="app-logo" />
                <img class="navbar-brand-minimized" src="img/logo.png" width="40" height="auto" alt="app-logo" />
            </b-link>
            <SidebarToggler class="d-md-down-none" display="lg" />
            <b-navbar-nav class="ml-auto">
                <b-nav-item class="d-md-down-none">
                    <span class="d-flex justify-content-end">{{
                        $store.getters.usuario.nome
                    }}</span>
                    <span v-if="fornecedor.fornecedorId" class="d-flex justify-content-end">
                        <br />
                        <strong>{{ fornecedor.razaoSocial }}</strong>
                    </span>
                </b-nav-item>
                <DefaultHeaderDropdownAccnt />
                <b-nav-item class="d-md-down-none">
                    <ultimo-acesso></ultimo-acesso>
                </b-nav-item>
                <b-nav-item class="d-md-down-none">
                    <app-tempo-sessao></app-tempo-sessao>
                </b-nav-item>
                <b-nav-item>
                    <i class="fa fa-sign-out fa-lg" @click.stop="$store.dispatch('logout')" title="Sair"></i>
                </b-nav-item>
            </b-navbar-nav>
        </AppHeader>
        <div class="app-body">
            <AppSidebar fixed>
                <SidebarHeader />
                <SidebarForm />
                <SidebarNav :navItems="navMenu"></SidebarNav>
                <SidebarFooter />
                <SidebarMinimizer />
            </AppSidebar>
            <main class="main pt-4 opaco">
                <div class="container-fluid">
                    <router-view></router-view>
                </div>
            </main>
            <AppAside fixed>
            </AppAside>
        </div>
        <TheFooter>
            <!--footer-->
            <span class="mr-auto">
                <span class="ml-1">&copy; {{ new Date().getFullYear() }} SUAPE</span>
            </span>
            <span class="mx-auto">
                <strong>ESPAÇO FORNECEDOR v{{ versao }}</strong>
            </span>
            <span class="ml-auto">
                <span class="mr-1">Powered by</span>
                <a href="http://www.bluetechnology.com.br/">Blue</a>
            </span>
        </TheFooter>
    </div>
</template>

<script>
import {
    Aside as AppAside,
    Header as AppHeader,
    Sidebar as AppSidebar,
    AsideToggler,
    Breadcrumb,
    SidebarFooter,
    SidebarForm,
    SidebarHeader,
    SidebarMinimizer,
    SidebarNav,
    SidebarToggler,
    Footer as TheFooter
} from '@coreui/vue'
// import DefaultAside from './DefaultAside'
import UltimoAcesso from './../shared/components/UltimoAcesso'
import DefaultHeaderDropdownAccnt from './DefaultHeaderDropdownAccnt'

export default {
    name: 'DefaultContainer',
    components: {
        AsideToggler,
        AppHeader,
        AppSidebar,
        AppAside,
        TheFooter,
        Breadcrumb,
        // DefaultAside,
        DefaultHeaderDropdownAccnt,
        SidebarForm,
        SidebarFooter,
        SidebarToggler,
        SidebarHeader,
        SidebarNav,
        SidebarMinimizer,
        UltimoAcesso
    },
    data() {
        return {
            versao: process.env.VUE_APP_VERSION
        }
    },
    computed: {
        name() {
            return this.$route.name
        },
        list() {
            return this.$route.matched.filter(
                (route) => route.name || route.meta.label
            )
        },
        navMenu() {
            return this.$store.getters.menu
        },
        fornecedor() {
            return this.$store.getters.fornecedor
        }
    }
}
</script>
